export default {
    methods: {
        createChartMonthsLabels(data) {
            const labels = []

            data.forEach((i) => {
                if (i.month > 0) {
                    labels.push(`${i.month}/${i.year}`)
                }
            })

            return labels
        },
        createChartFullYearMonthsLabels(data) {
            const labels = []
            const year = data[0].year

            for(let i = 1; i <= 12; i++) {
                labels.push(`${i}/${year}`)
            }

            return labels
        },
    },
}
